import { AlphabetLatinIcon } from './AlphabetLatinIcon';

/**
 * author: Haley Halcyon
 * id 07851190-1E8F-43D3-A5BF-01A120C0A3FB
 * name alphabet-latin
 * version: 4.9.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alphabet-latin.svg
 * tags
 * - Alpha / Numeric 
 */
export const WritingSystemLatinIcon = AlphabetLatinIcon;
export default WritingSystemLatinIcon